var _path, _path2, _g, _path3, _path4, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDxpay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 391,
    height: 233,
    viewBox: "0 0 391 233",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M335.032 55.8386L390.866 0H335.032H316.418L237.181 79.2369L199.951 116.461L237.181 153.695L316.418 232.927H335.032H390.866L335.032 177.088L274.405 116.461L335.032 55.8386Z",
    fill: "url(#paint0_linear_232_1645)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_232_1645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 199,
    y: 0,
    width: 192,
    height: 233
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M335.032 55.8386L390.866 0H335.032H316.418L237.181 79.2369L199.951 116.461L237.181 153.695L316.418 232.927H335.032H390.866L335.032 177.088L274.405 116.461L335.032 55.8386Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_232_1645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M390.871 0H199.951V232.927H390.871V0Z",
    fill: "url(#paint1_linear_232_1645)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.18 79.2369L157.938 0H0V52.6461H136.136L199.951 116.461L136.136 180.281H0V232.927H157.938L237.18 153.695L274.404 116.461L237.18 79.2369Z",
    fill: "url(#paint2_linear_232_1645)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_232_1645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 275,
    height: 233
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M237.18 79.2369L157.938 0H0V52.6461H136.136L199.951 116.461L136.136 180.281H0V232.927H157.938L237.18 153.695L274.404 116.461L237.18 79.2369Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_232_1645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M274.404 0H0V232.927H274.404V0Z",
    fill: "url(#paint3_linear_232_1645)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_232_1645",
    x1: 295.409,
    y1: 0,
    x2: 295.409,
    y2: 232.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5997F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D77FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_232_1645",
    x1: 295.411,
    y1: 0,
    x2: 295.411,
    y2: 232.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5997F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D77FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_232_1645",
    x1: 137.202,
    y1: 0,
    x2: 137.202,
    y2: 232.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5997F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D77FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_232_1645",
    x1: 137.202,
    y1: 0,
    x2: 137.202,
    y2: 232.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5997F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D77FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDxpay);
export default __webpack_public_path__ + "static/media/IconDxpay.650ff3cfa45ffd2a62447ff92c8873b0.svg";
export { ForwardRef as ReactComponent };